import { BodyText, Buttons, CloseButton, DismissTextButton, TitleRow } from './parts';
import { COLOR_BORDER_ASSISTIVE, FONT_FAMILY, Gray900, RADIUS_MD, RADIUS_SM, SHADOW_NOTICE, SP, White } from './tokens';
import type { PopupCardContent } from './types';
import { reverseWithOriginalIndex } from './utils';
export function MobileBottomCard({
  content,
  onClose,
  onButtonClick,
  onDismiss
}: {
  content: PopupCardContent;
  onClose?: () => void;
  onButtonClick?: (index: number, url?: string) => void;
  onDismiss?: () => void;
}) {
  const handleClose = () => {
    onDismiss?.();
    onClose?.();
  };
  const buttons = reverseWithOriginalIndex(content.buttons);
  return <div style={{
    position: 'relative',
    width: '100%',
    backgroundColor: White,
    border: `1px solid ${COLOR_BORDER_ASSISTIVE}`,
    borderRadius: RADIUS_MD,
    boxShadow: SHADOW_NOTICE,
    fontFamily: FONT_FAMILY,
    color: Gray900,
    padding: `${SP.md} ${SP.lg}`,
    display: 'flex',
    flexDirection: 'column',
    gap: SP.md,
    pointerEvents: 'auto'
  }} data-sentry-component="MobileBottomCard" data-sentry-source-file="MobileBottomCard.tsx">
      <CloseButton onClick={handleClose} withShadow style={{
      position: 'absolute',
      right: '-12px',
      top: '-16px',
      width: '36px',
      height: '36px'
    }} data-sentry-element="CloseButton" data-sentry-source-file="MobileBottomCard.tsx" />
      <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      gap: SP.md
    }}>
        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: SP['3xs'],
        flex: 1
      }}>
          <TitleRow title={content.title} data-sentry-element="TitleRow" data-sentry-source-file="MobileBottomCard.tsx" />
          {content.body && <BodyText>{content.body}</BodyText>}
        </div>
        {content.imageUrl && <img src={content.imageUrl} alt={content.title} style={{
        width: '58px',
        height: '58px',
        borderRadius: RADIUS_SM,
        objectFit: 'cover',
        flex: 'none'
      }} />}
      </div>
      <Buttons buttons={buttons} onButtonClick={onButtonClick} onClose={onClose} data-sentry-element="Buttons" data-sentry-source-file="MobileBottomCard.tsx" />
      <DismissTextButton dismissText={content.dismissText} onDismiss={onDismiss} onClose={onClose} data-sentry-element="DismissTextButton" data-sentry-source-file="MobileBottomCard.tsx" />
    </div>;
}